import {useEffect} from 'react';

import {browserHistory, WithRouterProps} from 'react-router';

import {useAttemptQuiz, useQuiz} from 'app/quizzes/api';

type Props = WithRouterProps<{
  hashid: string;
  attemptid?: string;
}>;

export const RedirectToTakeQuizPage = ({params}: Props) => {
  const {hashid, attemptid} = params;
  const {data: quiz} = useQuiz(hashid);
  const [attemptQuiz] = useAttemptQuiz();

  const takeQuiz = () => {
    if (quiz && !attemptid) {
      attemptQuiz({quiz: quiz.url})
        .unwrap()
        .then((attempt) => {
          browserHistory.push(attempt.take_url);
        })
        .catch(() => browserHistory.push(quiz.html_url));
    }
  };

  useEffect(() => {
    takeQuiz();
  }, [quiz]);

  return null;
};
